import { getDepreciationHistory } from '@encarpkg/api';
import * as api from 'app/api';
import { INIT_CAR_STATUS } from 'app/constants/carStatus';
import { DATA_TYPE } from 'app/constants/dataType';
import { INIT_PRO_APPLY } from 'app/constants/proApply';
import { INIT_PRO_DELIVERY } from 'app/constants/proDelivery';
import produce from 'immer';
import cloneDeep from 'lodash/fp/cloneDeep';
import set from 'lodash/set';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

const INIT_DATA = 'estimate/INIT_DATA';
export const initData = createAction(INIT_DATA);

const SET_REVIEW = 'estimate/SET_REVIEW';
export const setReview = createAction(SET_REVIEW);

const SET_FAILED_REASON = 'estimate/SET_FAILED_REASON';
export const setFailedReason = createAction(SET_FAILED_REASON);

const RESET_REVIEW_DEALER = 'estimate/RESET_REVIEW_DEALER';
export const resetReviewDealer = createAction(RESET_REVIEW_DEALER);

const GET_ESTIMATE_TIME = 'estimate/GET_ESTIMATE_TIME';
export const getEstimateTime = createAction(GET_ESTIMATE_TIME, api.getEstimateTime);

const GET_REVIEW = 'estimate/GET_REVIEW';
export const getReview = createAction(GET_REVIEW, api.getEstimateReview);

const GET_REVIEW_DETAIL = 'estimate/GET_REVIEW_DETAIL';
export const getReviewDetail = createAction(GET_REVIEW_DETAIL, api.getEstimateReviewDetail);

const GET_DEALER = 'estimate/GET_DEALER';
export const getDealer = createAction(GET_DEALER, api.getEstimateDealer);

const GET_DEALER_SIMPLE = 'estimate/GET_DEALER_SIMPLE';
export const getDealerSimple = createAction(GET_DEALER_SIMPLE, api.getEstimateDealerSimple);

const GET_DEALER_PROFILE = 'estimate/GET_DEALER_PROFILE';
export const getDealerProfile = createAction(GET_DEALER_PROFILE, api.getDealerProfileForSeller);

const GET_DEALER_TRANSACTION_DETAIL = 'estimate/GET_DEALER_TRANSACTION_DETAIL';
export const getDealerTransactionDetail = createAction(GET_DEALER_TRANSACTION_DETAIL, api.getDealerTransactionDetailForSeller);

const GET_CAR = 'estimate/GET_CAR';
export const getCar = createAction(GET_CAR, api.getEstimateCar);

const GET_BID = 'estimate/GET_BID';
export const getBid = createAction(GET_BID, api.getEstimateBid);

const GET_SECURE_BID = 'estimate/GET_SECURE_BID';
export const getSecureBid = createAction(GET_SECURE_BID, api.getEstimateSecureBid);

const GET_BIDS = 'estimate/GET_BIDS';
export const getBids = createAction(GET_BIDS, api.getEstimateBids);

const GET_BID_DEALER = 'estimate/GET_BID_DEALER';
export const getBidDealer = createAction(GET_BID_DEALER, api.getEstimateBidDealer);

const POST_REVIEW = 'estimate/POST_REVIEW';
export const postReview = createAction(POST_REVIEW, api.postEstimateReview);

const GET_CAR_STATUS = 'estimate/GET_CAR_STATUS';
export const getCarStatus = createAction(GET_CAR_STATUS, api.getEstimateApplyByTempId);

const SET_CAR_STATUS = 'estimate/SET_CAR_STATUS';
export const setCarStatus = createAction(SET_CAR_STATUS);

const SET_TEMP_CAR_STATUS = 'estimate/SET_TEMP_CAR_STATUS';
export const setTempCarStatus = createAction(SET_TEMP_CAR_STATUS);

const SET_ORIGIN_CAR_STATUS = 'estimate/SET_ORIGIN_CAR_STATUS';
export const setOriginCarStatus = createAction(SET_ORIGIN_CAR_STATUS);

const CLEAR_TEMP_CAR_STATUS_CONDITION = 'estimate/CLEAR_TEMP_CAR_STATUS_CONDITION';
export const clearTempCarStatusCondition = createAction(CLEAR_TEMP_CAR_STATUS_CONDITION);

const CLEAR_TEMP_CAR_STATUS_ACCIDENT = 'estimate/CLEAR_TEMP_CAR_STATUS_ACCIDENT';
export const clearTempCarStatusAccident = createAction(CLEAR_TEMP_CAR_STATUS_ACCIDENT);

const GET_APPLY_COMMON_INQUIRY_TEMP_ID = 'estimate/GET_APPLY_COMMON_INQUIRY_TEMP_ID';
export const getApplyCommonInquiryTempId = createAction(GET_APPLY_COMMON_INQUIRY_TEMP_ID, api.getApplyCommonInquiryTempId);

const SET_APPLY_COMMON = 'estimate/SET_APPLY_COMMON';
export const setApplyCommon = createAction(SET_APPLY_COMMON);

const RESET_APPLY_COMMON = 'estimate/RESET_APPLY_COMMON';
export const resetApplyCommon = createAction(RESET_APPLY_COMMON);

const POST_CAR_STATUS = 'estimate/POST_CAR_STATUS';
export const postCarStatus = createAction(POST_CAR_STATUS, api.postCarStatusInquiryTemp);

const PUT_CAR_STATUS = 'estimate/PUT_CAR_STATUS';
export const putCarStatus = createAction(PUT_CAR_STATUS, api.putEstimateInquiryTemporary);

const CHANGE_VALUE = 'estimate/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);

const SET_PRO_APPLY_INFO = 'estimate/SET_PRO_APPLY_INFO';
export const setProApplyInfo = createAction(SET_PRO_APPLY_INFO);

const RESET_PRO_APPLY_INFO = 'estimate/RESET_PRO_APPLY_INFO';
export const resetProApplyInfo = createAction(RESET_PRO_APPLY_INFO);

const SET_PRO_DELIVERY_INFO = 'estimate/SET_PRO_DELIVERY_INFO';
export const setProDeliveryInfo = createAction(SET_PRO_DELIVERY_INFO);

const RESET_PRO_DELIVERY_INFO = 'estimate/RESET_PRO_DELIVERY_INFO';
export const resetProDeliveryInfo = createAction(RESET_PRO_DELIVERY_INFO);

const GET_PRO_DELIVERY_DATE = 'estimate/GET_PRO_DELIVERY_DATE';
export const getProDeliveryDate = createAction(GET_PRO_DELIVERY_DATE, api.getProDeliveryDateList);

const SET_PRO_CONTRACT_IMG = 'estimate/SET_PRO_CONTRACT_IMG';
export const setProContractImg = createAction(SET_PRO_CONTRACT_IMG);

const GET_DEPRECIATION_HISTORY = 'estimate/GET_DEPRECIATION_HISTORY';
export const getDepreciationHistoryInfo = createAction(GET_DEPRECIATION_HISTORY, getDepreciationHistory);

const GET_PRO_ABLE_APPLY_DATE = 'estimate/GET_PRO_ABLE_APPLY_DATE';
export const getProAvailableEvaluatorTime = createAction(GET_PRO_ABLE_APPLY_DATE, api.getProAvailableEvaluatorTimeList);

const GET_OWNER_NAMES = 'estimate/GET_OWNER_NAMES';
export const getOwnerNames = createAction(GET_OWNER_NAMES, api.getOwnerNames);

const GET_CORPORATE_SELLER_STATUS = 'estimate/GET_CORPORATE_SELLER_STATUS';
export const getCorporateSellerStatus = createAction(GET_CORPORATE_SELLER_STATUS, api.getCorporateSellerStatus);

const GET_PRO_BUSINESS_STATUS = 'estimate-pro/GET_BUSINESS_STATUS';
export const getProBusinessStatus = createAction(GET_PRO_BUSINESS_STATUS, api.getProBusinessStatus);

const initialState = {
	init: {
		review: false,
		reviewDetail: false,
		dealer: false,
		sheet: false,
	},
	time: {},
	review: {},
	reviewDetail: {},
	reviewDealerContent: [],
	dealer: {},
	dealerSimple: {},
	dealerProfile: {},
	car: {},
	bid: {},
	bidDealer: {},
	bids: [],
	requestReview: {
		description: '',
		dealPrice: 0,
		rating: 5,
		failedReason: {
			DISSATISFIED_QUOTE: false,
			FALSE_ESTIMATE: false,
			CANT_CONTACTED: false,
			NOT_KIND: false,
			UNFAIR_DEPRECIATION: false,
			JUST_ESTIMATE: false,
			ETC: false,
		},
	},
	applyCommon: {
		temporaryId: '',
		estimateId: null,
		carNumber: '',
	},
	carStatus: {
		temp: INIT_CAR_STATUS,
		origin: INIT_CAR_STATUS,
	},
	proApplyInfo: {
		[DATA_TYPE.ORIGIN]: INIT_PRO_APPLY,
		[DATA_TYPE.TEMP]: INIT_PRO_APPLY,
	},
	proDeliveryInfo: {
		[DATA_TYPE.ORIGIN]: INIT_PRO_DELIVERY,
		[DATA_TYPE.TEMP]: INIT_PRO_DELIVERY,
	},
	proContractImg: {
		basic: '',
		detail: '',
	},
	depreciationHistory: {
		content: [],
		pageable: {
			pageNumber: 0,
		},
	},
	depreciationHistoryForSeller: {
		content: [],
		pageable: {
			pageNumber: 0,
		},
	},
	hometaxBusinessTypeList: [],
	ownerNames: [],
	corporateSellerStatus: false,
};

export default handleActions(
	{
		[INIT_DATA]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['init', name], value);
			}),

		[SET_REVIEW]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['requestReview', name], value);
			}),

		[SET_FAILED_REASON]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				set(draft, ['requestReview', 'failedReason', name], value);
			}),

		[RESET_REVIEW_DEALER]: (state) =>
			produce(state, (draft) => {
				set(draft, 'reviewDealerContent', []);
			}),

		[SET_CAR_STATUS]: (state, action) =>
			produce(state, (draft) => {
				const tempStatus = cloneDeep(state.carStatus);
				set(draft, ['carStatus'], { ...tempStatus, ...action.payload });
			}),

		[SET_ORIGIN_CAR_STATUS]: (state, action) =>
			produce(state, (draft) => {
				const tempStatus = cloneDeep(state.carStatus.origin);
				set(draft, ['carStatus', 'origin'], { ...tempStatus, ...action.payload });
			}),

		[SET_TEMP_CAR_STATUS]: (state, action) =>
			produce(state, (draft) => {
				const tempStatus = cloneDeep(state.carStatus.temp);
				set(draft, ['carStatus', 'temp'], { ...tempStatus, ...action.payload });
			}),

		[CLEAR_TEMP_CAR_STATUS_CONDITION]: (state) =>
			produce(state, (draft) => {
				draft.carStatus.temp.smartKeyCount = null;
				draft.carStatus.temp.panelScratchCount = null;
				draft.carStatus.temp.wheelScratchCount = null;
				draft.carStatus.temp.badTireStatusType = null;
				draft.carStatus.temp.additionalRepairNeededPart = '';
			}),

		[CLEAR_TEMP_CAR_STATUS_ACCIDENT]: (state) =>
			produce(state, (draft) => {
				draft.carStatus.temp.panel = INIT_CAR_STATUS.panel;
				draft.carStatus.temp.frame = INIT_CAR_STATUS.frame;
				draft.carStatus.temp.exchangeComment = INIT_CAR_STATUS.exchangeComment;
				draft.carStatus.temp.additionalComment = INIT_CAR_STATUS.additionalComment;
			}),

		[SET_APPLY_COMMON]: (state, action) =>
			produce(state, (draft) => {
				const temp = cloneDeep(state.applyCommon);
				set(draft, ['applyCommon'], { ...temp, ...action.payload });
			}),

		[RESET_APPLY_COMMON]: (state) =>
			produce(state, (draft) => {
				draft.applyCommon.temporaryId = '';
				draft.applyCommon.estimateId = null;
			}),

		[SET_PRO_APPLY_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { type, data } = action.payload;
				const tempStatus = cloneDeep(state.proApplyInfo[type]);
				set(draft, ['proApplyInfo', type], { ...tempStatus, ...data });
			}),

		[RESET_PRO_APPLY_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { type } = action.payload;
				set(draft, ['proApplyInfo', type], INIT_PRO_APPLY);
			}),

		[SET_PRO_DELIVERY_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { type, data } = action.payload;
				const tempStatus = cloneDeep(state.proDeliveryInfo[type]);
				set(draft, ['proDeliveryInfo', type], { ...tempStatus, ...data });
			}),

		[RESET_PRO_DELIVERY_INFO]: (state, action) =>
			produce(state, (draft) => {
				const { type } = action.payload;
				set(draft, ['proDeliveryInfo', type], INIT_PRO_DELIVERY);
			}),

		...pender({
			type: GET_PRO_ABLE_APPLY_DATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const tempStatus = cloneDeep(state.proApplyInfo[DATA_TYPE.TEMP]);
					const availableDateTimeList = Object.keys(data?.result || {}).map((date) => ({
						date,
						time: data.result[date],
					}));
					set(draft, ['proApplyInfo', DATA_TYPE.TEMP], { ...tempStatus, availableDateTimeList });
				}),
		}),

		...pender({
			type: GET_PRO_DELIVERY_DATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const tempStatus = cloneDeep(state.proDeliveryInfo[DATA_TYPE.TEMP]);
					const availableDateTimeList = data?.availableDateList || [];
					set(draft, ['proDeliveryInfo', DATA_TYPE.TEMP], { ...tempStatus, availableDateTimeList });
				}),
		}),

		...pender({
			type: GET_APPLY_COMMON_INQUIRY_TEMP_ID,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, ['applyCommon', 'temporaryId'], data || '');
				}),
		}),

		...pender({
			type: GET_CAR_STATUS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = {
						smartKeyCount: data?.smartKeyCount || null,
						panelScratchCount: data?.panelScratchCount || null,
						wheelScratchCount: data?.wheelScratchCount || null,
						badTireStatusType: data?.badTireStatusType || null,
						additionalRepairNeededPart: data?.additionalRepairNeededPart || '',
						exchangeType: data?.exchangeType || null,
						exchangeComment: data?.exchangeComment || null,
						panel: data?.panel || INIT_CAR_STATUS.panel,
						frame: data?.frame || INIT_CAR_STATUS.frame,
					};
					set(draft, ['carStatus', 'origin'], result);
				}),
		}),

		...pender({
			type: GET_DEPRECIATION_HISTORY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { depreciationHistory } = state;
					const isFirstPage = action.payload.data.pageable.pageNumber === 0;
					const result = {
						...data,
						content: isFirstPage ? data.content : depreciationHistory.content.concat(data.content),
					};
					set(draft, ['depreciationHistory'], result);
				}),
		}),

		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),

		...pender({
			type: GET_ESTIMATE_TIME,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'time', data || {});
				}),
		}),

		...pender({
			type: GET_REVIEW,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'review', data || {});
				}),
		}),

		...pender({
			type: GET_REVIEW_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'reviewDetail', data || {});
				}),
		}),

		...pender({
			type: GET_DEALER,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'dealer', data || {});
				}),
		}),

		...pender({
			type: GET_DEALER_SIMPLE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'dealerSimple', data || {});
				}),
		}),

		...pender({
			type: GET_DEALER_PROFILE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'dealerProfile', data || {});
				}),
		}),

		...pender({
			type: GET_DEALER_TRANSACTION_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { depreciationHistoryForSeller } = state;
					const isFirstPage = action.payload.data.pageable.pageNumber === 0;
					const result = {
						...data,
						content: isFirstPage ? data.content : depreciationHistoryForSeller.content.concat(data.content),
					};
					set(draft, 'depreciationHistoryForSeller', result);
				}),
		}),

		...pender({
			type: GET_CAR,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'car', data || {});
				}),
		}),

		...pender({
			type: GET_BIDS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'bids', data || []);
				}),
		}),

		...pender({
			type: GET_SECURE_BID,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'bid', data || {});
				}),
		}),

		...pender({
			type: GET_BID,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'bid', data || {});
				}),
		}),

		...pender({
			type: GET_BID_DEALER,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'bidDealer', data || {});
				}),
		}),

		[SET_PRO_CONTRACT_IMG]: (state, action) =>
			produce(state, (draft) => {
				const { type, data } = action.payload;
				set(draft, ['proContractImg', type], data);
			}),

		...pender({
			type: GET_OWNER_NAMES,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const ownerNames = Array.isArray(data?.ownerNames) ? data.ownerNames : [];
					draft.ownerNames = [...ownerNames];
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.ownerNames = [];
				}),
		}),

		...pender({
			type: GET_CORPORATE_SELLER_STATUS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.corporateSellerStatus = data === 'TRUE';
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.corporateSellerStatus = false;
				}),
		}),

		...pender({
			type: GET_PRO_BUSINESS_STATUS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.hometaxBusinessTypeList = Array.isArray(data?.ownershipBusinessType?.hometaxBusinessTypeList)
						? [...data.ownershipBusinessType.hometaxBusinessTypeList]
						: [];
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.hometaxBusinessTypeList = [];
				}),
		}),
	},
	initialState,
);
